// Extend namespace by creating a new object
pyzel.surfboards = pyzel.surfboards || {};

/**
 * Initialize listeners
 *
 * @return {void}
 */
pyzel.surfboards.init = function() {

	// Init slider status
	if ( typeof pyzel.surfboards.sliderInitiated == undefined ) {
		pyzel.surfboards.sliderInitiated = false;
	}

	// Check for clicks on View all
	// Use this function as an example only, data should be obtained by an ajax call to the server
	$('.js-surfboards-view-all').on('click', function(){
		pyzel.surfboards.addAll( $(this) );
	});

};

/**
 * Adds more surfboards to the container, just for demo usage in the static HTML version
 * @todo refactor this in the dynamic / production version, should get data from an Ajax request with the surfboard category
 *
 * @param {object} el Element
 *
 * @return {void}
 */
pyzel.surfboards.addAll = function(el) {

	var category = el.data('category');

	// Hide the button
	el.css('opacity', 0);

	// This should be an Ajax call
	var firstSurfboard = '<div class="col-sm-4"><a href="index.php?page=surfboards-ratskull" class="slide surfboard-listing-single"><div class="name">The Amigo</div><div class="price">860.00 EUR</div><img src="/images/surfboards-theamigo.jpg" width="340" height="425" alt="Surfboard"><div class="category">High performance</div><div class="specs">0-4ft / Intermed to Advance</div><div class="btn btn-primary btn-sm">See more</div></a></div>';
	var secondSurfboard = '<div class="col-sm-4"><a href="index.php?page=surfboards-ratskull" class="slide surfboard-listing-single"><div class="name">The Amp</div><div class="price">860.00 EUR</div><img src="/images/surfboards-theamp.jpg" width="340" height="425" alt="Surfboard"><div class="category">High performance</div><div class="specs">0-4ft / Intermed to Advance</div><div class="btn btn-primary btn-sm">See more</div></a></div>';
	var thirdSurfboard = '<div class="col-sm-4"><a href="index.php?page=surfboards-ratskull" class="slide surfboard-listing-single"><div class="name">The Slab</div><div class="price">860.00 EUR</div><img src="/images/surfboards-theslab.jpg" width="340" height="425" alt="Surfboard"><div class="category">High performance</div><div class="specs">0-4ft / Intermed to Advance</div><div class="btn btn-primary btn-sm">See more</div></a></div>';

	if ( !$('.js-boards-list-slider').hasClass('slick-initialized') ) {

		$('.js-boards-' + category).append(firstSurfboard + secondSurfboard + thirdSurfboard);

	} else {

		// Slider is enabled, add as new slides
		$('.js-boards-' + category).slick('slickAdd', firstSurfboard);
		$('.js-boards-' + category).slick('slickAdd', secondSurfboard);
		$('.js-boards-' + category).slick('slickAdd', thirdSurfboard);

	}


};